<!--
 * @FilePath: CancelDialog.vue
 * @Author: Aron
 * @Date: 2023-08-03 10:38:22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-03 11:01:10
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
-->
<template>
  <el-dialog center title="" :visible.sync="dialogVisible" :show-close="false" custom-class="secondary-confirmation"
    :width="width">
    <div class="main-dialog-content">
      <div class="warn-img">
        <img src="@/assets/images/warning.png" />
      </div>
      <div class="text">{{ $t('app.auto_576_be030eaf') }}</div>
      <slot></slot>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogCancel" type="text"
        style="width: 50%;height:50px;margin:0;box-sizing: border-box;border-right:1px solid #e8e8e8;color:#606266">{{ $t('app.auto_576_be030eaf') }}</el-button>
      <el-button @click="dialogConfirm" type="text"
        style="width: 50%;height:50px;margin:0;color:#606266;box-sizing: border-box;">{{ $t('app.auto_68_3c08da52') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    width: {
      default: "25%"
    }
  },
  methods: {
    dialogCancel() {
      this.$emit("dialogCancel");
    },
    dialogConfirm() {
      this.$emit("dialogConfirm");
    }
  }
};
</script>

<style lang="scss">
.secondary-confirmation {
  position: relative;
  border-radius: 10px;

  .el-dialog__footer {
    padding: 0 !important;
    border-top: 1px solid #e0e0e0;
  }

  .el-dialog__body {
    padding: 0;

    .dialog-content {
      // margin-top: -90px;
      .dialog-title {
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #4A83E8;
        line-height: 22px;
      }

      .kouchu-wrap {
        width: 180px;
        margin: 0 auto;
      }

      .confirm-text {
        padding: 10px;
        text-align: center;
        font-size: 16px;
      }

      .tips-1 {
        margin-top: 20px;
        margin-bottom: 20px;
        // text-align: center;
        font-size: 16px;
      }

      .kouchu-money-ul {
        li {
          // text-align: center;
          margin-bottom: 10px;
          font-size: 16px;
        }
      }
    }

    .main-dialog-content {
      display: flex;
      flex-direction: column;
    }

    .warn-img {
      position: absolute;
      width: 100px;
      height: 100px;
      left: 50%;
      top: -50px;
      transform: translateX(-50px);
      // background-color: #fff;
      // border-radius: 50%;

      img {
        width: 100px;
        height: 100px;
      }
    }

    .text {
      width: 100%;
      text-align: center;
      padding: 0;
      margin-top: 25px;
      color: #4A83E8;
      font-size: 16px;
    }

    .dialog-footer {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
